import { Component } from "@angular/core";

@Component({
  selector: "li[listbox-element], listbox-element",
  templateUrl: "./listbox-element.component.html",
  styleUrls: ["./listbox-element.component.scss"],
})
export class ListboxElementComponent {}
